import React, {useEffect, useState} from "react";
import TokenStorage from "../ABDMStorage";
export default function TokenStatus() {
    const [tokens, setTokens] = useState({
        access: null, xtoken: null, ttoken: null, txn: null, abha: null, address: null
    });
    const loadTokens = () => {
        setTokens({
            access: TokenStorage.getAccessToken(),
            xtoken: TokenStorage.getXToken(),
            ttoken: TokenStorage.getTToken(),
            txn: TokenStorage.getTxnId(),
            abha: TokenStorage.getAbhaNumber(),
            address: TokenStorage.getAbhaAddress()
        });
    };
    useEffect(() => {
        loadTokens();
        const timer = setInterval(loadTokens, 1000);
        return () => clearInterval(timer);
    }, []);
    const status = value => value ? <span className="badge bg-success">

                Available

            </span> : <span className="badge bg-danger">

                Missing

            </span>;
    return (<div className="card shadow-sm">

        <div className="card-header bg-success text-white">

            <strong>

                ABDM Session

            </strong>

        </div>

        <div className="card-body">

            <table className="table table-sm">

                <tbody>

                <tr>

                    <td width="40%">

                        Gateway Token

                    </td>

                    <td>

                        {status(tokens.access)}

                    </td>

                </tr>

                <tr>

                    <td>

                        X Token

                    </td>

                    <td>

                        {status(tokens.xtoken)}

                    </td>

                </tr>

                <tr>

                    <td>

                        T Token

                    </td>

                    <td>

                        {status(tokens.ttoken)}

                    </td>

                </tr>

                <tr>

                    <td>

                        Transaction ID

                    </td>

                    <td>

                        {tokens.txn ? <small>

                            {tokens.txn}

                        </small> : "-"}

                    </td>

                </tr>

                <tr>

                    <td>

                        ABHA Number

                    </td>

                    <td>

                        {tokens.abha ? tokens.abha : "-"}

                    </td>

                </tr>

                <tr>

                    <td>

                        ABHA Address

                    </td>

                    <td>

                        {tokens.address ? tokens.address : "-"}

                    </td>

                </tr>

                </tbody>

            </table>

            <div className="d-grid mt-3">

                <button

                    className="btn btn-outline-danger"

                    onClick={() => {
                        localStorage.removeItem("ABDM_ACCESS_TOKEN");
                        localStorage.removeItem("ABDM_X_TOKEN");
                        localStorage.removeItem("ABDM_T_TOKEN");
                        localStorage.removeItem("ABDM_TXN_ID");
                        localStorage.removeItem("ABDM_ABHA_NUMBER");
                        localStorage.removeItem("ABDM_ABHA_ADDRESS");
                        localStorage.removeItem("ABDM_PROFILE");
                        loadTokens();
                    }}

                >

                    Clear ABDM Session

                </button>

            </div>

        </div>

    </div>);
}